import { render } from "./CodeScreen.vue?vue&type=template&id=1e651ff0&scoped=true&lang=html"
import script from "./CodeScreen.vue?vue&type=script&lang=js"
export * from "./CodeScreen.vue?vue&type=script&lang=js"

import "./CodeScreen.vue?vue&type=style&index=0&id=1e651ff0&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/multiple_choice_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e651ff0"]])

export default __exports__